import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { WalkIcon } from '../../../../assets/images/activityIcons';

const ExerciseDataItem = ({
    icon: Icon = WalkIcon,
    value,
    unit,
    value2 = null,
    unit2 = '',
    label,
    size = 'medium',
    iconColor = '#9ad700',
    sx = {},
    ...props
}) => {
    const theme = useTheme();

    const containerStyles = {
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        alignSelf: 'stretch',
        ...sx,
    };

    const valueStyles = {
        fontSize: size === 'small' ? '16px' : '20px',
        fontWeight: 600,
        letterSpacing: '-0.6px',
        lineHeight: 'normal',
    };

    const unitStyles = {
        fontSize: size === 'small' ? '12px' : '14px',
        color: theme.palette.figma.white[60],
        letterSpacing: '-0.42px',
        lineHeight: 'normal',
    };

    const labelStyles = {
        fontSize: '12px',
        color: theme.palette.figma.white[60],
        fontWeight: 400,
        lineHeight: 'normal',
        letterSpacing: '-0.36px',
        textAlign: "left"
    };

    return (
        <Box sx={containerStyles} {...props}>
            <Box
                sx={{
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: size === 'small' ? '20px' : '30px',
                    height: size === 'small' ? '20px' : '30px',
                }}
            >
                <Icon size={size === 'small' ? 20 : 30} />
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    minWidth: 0, // flexbox에서 텍스트 오버플로우 허용
                    flex: 1,
                    overflow: 'visible', // 텍스트가 잘리지 않도록
                }}
            >
                {label && (
                    <Typography sx={labelStyles}>
                        {label}
                    </Typography>
                )}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '5px',
                        alignSelf: 'stretch',
                        flexWrap: 'nowrap',
                        minWidth: 0, // flexbox에서 텍스트 오버플로우 허용
                        overflow: 'visible', // 텍스트가 잘리지 않도록
                        width: '100%', // 전체 너비 사용
                    }}
                >
                    <Typography
                        sx={{
                            ...valueStyles,
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                        }}
                    >
                        {typeof value === 'number' ? value.toLocaleString() : value}
                    </Typography>
                    <Typography
                        sx={{
                            ...unitStyles,
                            whiteSpace: 'nowrap',
                            flexShrink: 0,
                        }}
                    >
                        {unit}
                    </Typography>
                    {value2 !== null && (
                        <Typography
                            sx={{
                                ...valueStyles,
                                whiteSpace: 'nowrap',
                                flexShrink: 0,
                            }}
                        >
                            {typeof value2 === 'number' ? value2.toLocaleString() : value2}
                        </Typography>
                    )}
                    {unit2 && (
                        <Typography
                            sx={{
                                ...unitStyles,
                                whiteSpace: 'nowrap',
                                flexShrink: 0,
                            }}
                        >
                            {unit2}
                        </Typography>
                    )}
                </Box>
            </Box>
        </Box >
    );
};

export default ExerciseDataItem;
